import { jsxs, jsx } from 'react/jsx-runtime';
import { useLocalization } from '@shared-ui/localization-context';
import { Viewport, ViewSmall, ViewLarge } from '@shared-ui/viewport-context';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { EGDSDialogAnimationType } from '../../dialog/dialog/index.esm.js';
import '../../dialog/dialog-content/index.esm.js';
import '../../dialog/dialog-footer/index.esm.js';
import { EGDSFullscreenDialog } from '../../dialog/fullscreen-dialog/index.esm.js';
import '../../input/input/index.esm.js';
import { EGDSFauxInput } from '../../input/faux-input/index.esm.js';
import { EGDSTextInput } from '../../input/text-input/index.esm.js';
import '../../input/password-input/index.esm.js';
import '../../input/informative-input/index.esm.js';
import '../../input/textarea/index.esm.js';
import '../../input/chat-textarea/index.esm.js';
import '../../input/fake-input/index.esm.js';
import '../../input/card-number-input/index.esm.js';
import '../../input/select/index.esm.js';
import '../../input/swapper-input/index.esm.js';
import '../../layout-flex/types/index.esm.js';
import { EGDSLayoutFlex } from '../../layout-flex/layout-flex/index.esm.js';
import { EGDSLayoutFlexItem } from '../../layout-flex/layout-flex-item/index.esm.js';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import { EGDSMenu } from '../../menu/menu/index.esm.js';
import { EGDSMenuTrigger } from '../../menu/menu-trigger/index.esm.js';
import { EGDSMenuContainer, PositionType } from '../../menu/menu-container/index.esm.js';
import '../../menu/menu-list/index.esm.js';
import '../../menu/menu-list-item/index.esm.js';
import '../../menu/menu-icon-trigger/index.esm.js';
import '../calendar/index.esm.js';
import { EGDSDatePickerRenderType } from '../date-picker/index.esm.js';
import '../day/index.esm.js';
import '../month/index.esm.js';
import '../date-picker-input/index.esm.js';
import { EGDSDatePickerDialogView } from '../date-picker-dialog-view/index.esm.js';
import { EGDSDatePickerMenuView } from '../date-picker-menu-view/index.esm.js';
import styles from '../../styles/uitk-egds-date-picker.css';
import { classNames } from '../../utils/classnames/index.esm.js';
import { EGDSContextProvider } from '../../utils/context-provider/index.esm.js';
const getClassNameList = classNames.bind(styles);
var EGDSDatePickerDateFormat;
(function (EGDSDatePickerDateFormat) {
  EGDSDatePickerDateFormat["YMD"] = "yyyy-MM-dd";
})(EGDSDatePickerDateFormat || (EGDSDatePickerDateFormat = {}));
const mapDatePickerProps = source => ({
  ...source.datePickerProps,
  onChangeEndDate: source.onChangeEndDate,
  onChangeMonth: source.onChangeMonth,
  onChangeStartDate: source.onChangeStartDate,
  onClearDates: source.onClearDates,
  onDismiss: source.onDismiss,
  onScrollHandler: source.onScrollHandler,
  onSubmit: source.onSubmit,
  preventAutoFocus: source.preventAutoFocus,
  singleMode: source.singleMode && !source.useSingleTrigger,
  useClearDates: source.useClearDates,
  useSingleTrigger: source.useSingleTrigger
});
/**
 * Get display values and values for date field
 */
const getFormattedDates = (l10n, dateProps, dateFormat, mediumDateFormatProp) => {
  const mediumDateFormat = {
    dateFormat: 'medium',
    skeleton: mediumDateFormatProp ?? 'MMMd'
  };
  const isoDateFormat = {
    dateFormat: 'iso-date',
    raw: dateFormat
  };
  const {
    value,
    placeholder
  } = dateProps;
  return {
    value: l10n.formatDate(value, isoDateFormat),
    formattedBtnText: value ? l10n.formatDate(value, mediumDateFormat) : placeholder,
    accessibleFormattedText: value ? l10n.formatDate(value, mediumDateFormat) : placeholder,
    label: jsx("span", {
      "aria-hidden": "true",
      children: dateProps.label
    })
  };
};
const CustomTriggerDialog = props => {
  const {
    updateViewport
  } = props;
  useEffect(() => {
    if (updateViewport) {
      updateViewport(true);
    }
  }, []);
  const enhancedDatePickerProps = mapDatePickerProps(props);
  return jsx(EGDSFullscreenDialog, {
    dialogShow: true,
    animation: EGDSDialogAnimationType.SLIDEUP,
    children: jsx(EGDSDatePickerDialogView, {
      ...enhancedDatePickerProps
    })
  });
};
const CustomTriggerMenu = props => {
  const {
    updateViewport
  } = props;
  useEffect(() => {
    if (updateViewport) {
      updateViewport(false);
    }
  }, []);
  const enhancedDatePickerProps = mapDatePickerProps(props);
  return jsx(EGDSDatePickerMenuView, {
    ...enhancedDatePickerProps
  });
};
CustomTriggerDialog.displayName = 'CustomTriggerDialog';
const DialogEndDateField = props => {
  const {
    dateFormat,
    endProps,
    l10n,
    mediumDateFormatProp,
    onChange,
    routerLinkWrapper
  } = props;
  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => {
    setIsMounted(true);
  }, []);
  if (!endProps) {
    return null;
  }
  const {
    value,
    accessibleFormattedText,
    formattedBtnText,
    label
  } = getFormattedDates(l10n, endProps, dateFormat, mediumDateFormatProp);
  const {
    dateType
  } = endProps;
  const buttonLabel = `${endProps.label} ${accessibleFormattedText}`;
  const setContext = () => {
    props.openDatePicker(dateType);
  };
  const textInputClasses = getClassNameList({
    'is-hidden': isMounted
  });
  return jsx(EGDSTextInput, {
    id: endProps.id,
    name: endProps.name,
    className: textInputClasses,
    label: label,
    placeholder: endProps.placeholder,
    value: value,
    onChange: onChange,
    "data-stid": "input-date",
    icon: "today",
    invalid: endProps.invalid,
    children: isMounted && routerLinkWrapper && routerLinkWrapper(jsx(EGDSFauxInput, {
      "aria-label": buttonLabel,
      className: getClassNameList('uitk-form-field-trigger'),
      domRef: endProps.domRef,
      "data-name": endProps.name,
      id: `${endProps.id}-btn`,
      "data-stid": "open-date-picker",
      type: "button",
      onClick: setContext,
      analytics: endProps.analytics,
      children: formattedBtnText
    }))
  });
};
DialogEndDateField.displayName = 'DialogEndDateField';
const DialogDateFields = props => {
  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => {
    setIsMounted(true);
    if (props.updateViewport) {
      props.updateViewport(true);
    }
  }, []);
  const {
    dateFieldWrapperClasses,
    dateFormat,
    dialogWrapper,
    l10n,
    mediumDateFormatProp,
    onChange,
    routerLinkWrapper,
    showDatePicker,
    singleMode,
    space,
    stacked,
    startProps,
    endProps,
    triggeredField,
    useSingleTrigger
  } = props;
  const {
    value: startValue,
    formattedBtnText: startFormattedBtnText,
    accessibleFormattedText: startAccessibleFormattedText,
    label: startLabel
  } = getFormattedDates(l10n, startProps, dateFormat, mediumDateFormatProp);
  let value = startValue;
  let formattedBtnText = startFormattedBtnText;
  let buttonLabel = `${startProps.label}`;
  if (startAccessibleFormattedText) {
    buttonLabel += ` ${startAccessibleFormattedText}`;
  }
  if (useSingleTrigger && endProps) {
    const {
      value: endValue,
      formattedBtnText: endFormattedBtnText,
      accessibleFormattedText: endAccessibleFormattedText
    } = getFormattedDates(l10n, endProps, dateFormat, mediumDateFormatProp);
    if (endValue) {
      value += ` - ${endValue}`;
    }
    if (endFormattedBtnText) {
      formattedBtnText += ` - ${endFormattedBtnText}`;
    }
    if (endAccessibleFormattedText) {
      buttonLabel = `${startProps.label} ${l10n.formatText('datepicker.buttonLabel.endAccessibleFormattedText', startAccessibleFormattedText, endAccessibleFormattedText)}`;
    }
  }
  const setContext = () => {
    const {
      dateType
    } = startProps;
    props.openDatePicker(dateType);
  };
  const shouldBeStacked = stacked && !singleMode && !useSingleTrigger;
  const fieldWrapperClasses = getClassNameList({
    'uitk-date-field-wrapper': !shouldBeStacked
  });
  const fieldLayoutDirection = shouldBeStacked ? 'column' : 'row';
  const wrapperClasses = getClassNameList({
    [`${dateFieldWrapperClasses}`]: dateFieldWrapperClasses
  }, 'uitk-date-fields-wrapper');
  const enhancedDatePickerProps = mapDatePickerProps(props);
  const textInputClasses = getClassNameList({
    'is-hidden': isMounted
  });
  return jsx(EGDSLayoutFlexItem, {
    className: wrapperClasses,
    grow: 1,
    children: jsxs(EGDSLayoutFlex, {
      className: getClassNameList('uitk-date-fields'),
      direction: fieldLayoutDirection,
      space: space,
      children: [showDatePicker && triggeredField && dialogWrapper(jsx(EGDSFullscreenDialog, {
        dialogShow: true,
        animation: EGDSDialogAnimationType.SLIDEUP,
        children: jsx(EGDSDatePickerDialogView, {
          ...enhancedDatePickerProps
        })
      }), triggeredField), jsx(EGDSLayoutFlexItem, {
        className: fieldWrapperClasses,
        grow: 1,
        minWidth: "zero",
        maxWidth: singleMode || useSingleTrigger || stacked ? undefined : 'half_width',
        children: jsx("div", {
          children: jsx(EGDSTextInput, {
            id: startProps.id,
            name: startProps.name,
            className: textInputClasses,
            label: startLabel,
            placeholder: startProps.placeholder,
            value: value,
            onChange: onChange,
            "data-stid": "input-date",
            icon: "today",
            invalid: startProps.invalid,
            children: isMounted && routerLinkWrapper && routerLinkWrapper(jsx(EGDSFauxInput, {
              "aria-label": buttonLabel,
              className: getClassNameList('uitk-form-field-trigger'),
              domRef: startProps.domRef,
              "data-name": startProps.name,
              id: `${startProps.id}-btn`,
              "data-stid": "open-date-picker",
              type: "button",
              onClick: setContext,
              analytics: startProps.analytics,
              children: formattedBtnText
            }))
          })
        })
      }), !singleMode && !useSingleTrigger && jsx(EGDSLayoutFlexItem, {
        className: fieldWrapperClasses,
        grow: 1,
        minWidth: "zero",
        maxWidth: stacked ? undefined : 'half_width',
        children: jsx("div", {
          children: jsx(DialogEndDateField, {
            ...props
          })
        })
      })]
    })
  });
};
DialogDateFields.displayName = 'DialogDateFields';
const MenuEndDateField = props => {
  const {
    dateFormat,
    mediumDateFormatProp,
    endProps,
    l10n,
    onChange,
    onSubmit,
    showDatePicker,
    triggeredField
  } = props;
  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => {
    setIsMounted(true);
  }, []);
  if (!endProps) {
    return null;
  }
  const {
    value,
    formattedBtnText,
    accessibleFormattedText,
    label
  } = getFormattedDates(l10n, endProps, dateFormat, mediumDateFormatProp);
  const {
    dateType
  } = endProps;
  const buttonLabel = `${endProps.label} ${accessibleFormattedText}`;
  const setContext = () => {
    props.openDatePicker(dateType);
  };
  // Make sure that both menus aren't opened at the same time on auto-open
  const isOpen = isMounted && showDatePicker;
  const containerClasses = getClassNameList('uitk-date-picker-menu-container', {
    'uitk-date-picker-menu-container-single': !endProps.doubleMonths,
    'uitk-date-picker-menu-container-double': endProps.doubleMonths
  });
  const enhancedDatePickerProps = mapDatePickerProps(props);
  const textInputClasses = getClassNameList({
    'is-hidden': isMounted
  });
  return jsx(EGDSContextProvider, {
    config: {
      context: 'egds-date-picker-context'
    },
    children: jsxs(EGDSMenu, {
      isOpen: isOpen,
      className: getClassNameList('uitk-date-picker-menu'),
      onDismiss: onSubmit,
      children: [jsx(EGDSMenuTrigger, {
        children: jsx(EGDSTextInput, {
          className: textInputClasses,
          id: endProps.id,
          name: endProps.name,
          label: label,
          placeholder: endProps.placeholder,
          value: value,
          onChange: onChange,
          "data-stid": "input-date",
          icon: "today",
          invalid: endProps.invalid,
          children: isMounted && jsx(EGDSFauxInput, {
            "aria-label": buttonLabel,
            className: getClassNameList('uitk-form-field-trigger'),
            domRef: endProps.domRef,
            "data-name": endProps.name,
            id: `${endProps.id}-btn`,
            "data-stid": "open-date-picker",
            type: "button",
            onClick: setContext,
            analytics: endProps.analytics,
            children: formattedBtnText
          })
        })
      }), showDatePicker && triggeredField === 'end' && jsx(EGDSMenuContainer, {
        position: PositionType.LEFT,
        className: containerClasses,
        autoPosition: true,
        children: jsx(EGDSDatePickerMenuView, {
          ...enhancedDatePickerProps
        })
      })]
    })
  });
};
MenuEndDateField.displayName = 'MenuEndDateField';
const MenuDateFields = props => {
  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => {
    setIsMounted(true);
    if (props.updateViewport) {
      props.updateViewport(false);
    }
  }, []);
  const {
    dateFieldWrapperClasses,
    dateFormat,
    l10n,
    mediumDateFormatProp,
    onChange,
    onSubmit,
    showDatePicker,
    singleMode,
    space,
    stacked,
    startProps,
    endProps,
    triggeredField,
    useSingleTrigger
  } = props;
  const {
    value: startValue,
    formattedBtnText: startFormattedBtnText,
    accessibleFormattedText: startAccessibleFormattedText,
    label: startLabel
  } = getFormattedDates(l10n, startProps, dateFormat, mediumDateFormatProp);
  let value = startValue;
  let formattedBtnText = startFormattedBtnText;
  let buttonLabel = `${startProps.label}`;
  if (startAccessibleFormattedText) {
    buttonLabel += ` ${startAccessibleFormattedText}`;
  }
  if (useSingleTrigger && endProps) {
    const {
      value: endValue,
      formattedBtnText: endFormattedBtnText,
      accessibleFormattedText: endAccessibleFormattedText
    } = getFormattedDates(l10n, endProps, dateFormat, mediumDateFormatProp);
    if (endValue) {
      value += ` - ${endValue}`;
    }
    if (endFormattedBtnText) {
      formattedBtnText += ` - ${endFormattedBtnText}`;
    }
    if (endAccessibleFormattedText) {
      buttonLabel = `${startProps.label} ${l10n.formatText('datepicker.buttonLabel.endAccessibleFormattedText', startAccessibleFormattedText, endAccessibleFormattedText)}`;
    }
  }
  const setContext = () => {
    props.openDatePicker(startProps.dateType);
  };
  const isOpen = showDatePicker;
  const containerClasses = getClassNameList('uitk-date-picker-menu-container', {
    'uitk-date-picker-menu-container-single': !startProps.doubleMonths,
    'uitk-date-picker-menu-container-double': startProps.doubleMonths
  });
  const enhancedDatePickerProps = mapDatePickerProps(props);
  const shouldBeStacked = stacked && !singleMode && !useSingleTrigger;
  const fieldWrapperClasses = getClassNameList({
    'uitk-date-field-wrapper': !shouldBeStacked
  });
  const fieldLayoutDirection = shouldBeStacked ? 'column' : 'row';
  const wrapperClasses = getClassNameList({
    [`${dateFieldWrapperClasses}`]: dateFieldWrapperClasses
  }, 'uitk-date-fields-wrapper');
  const textInputClasses = getClassNameList({
    'is-hidden': isMounted
  });
  return jsx(EGDSLayoutFlexItem, {
    className: wrapperClasses,
    grow: 1,
    children: jsxs(EGDSLayoutFlex, {
      className: getClassNameList('uitk-date-fields'),
      space: space,
      direction: fieldLayoutDirection,
      children: [jsx(EGDSLayoutFlexItem, {
        className: fieldWrapperClasses,
        grow: 1,
        minWidth: "zero",
        maxWidth: singleMode || useSingleTrigger || stacked ? undefined : 'half_width',
        children: jsx("div", {
          children: jsx(EGDSContextProvider, {
            config: {
              context: 'egds-date-picker-context'
            },
            children: jsxs(EGDSMenu, {
              isOpen: isOpen,
              className: getClassNameList('uitk-date-picker-menu'),
              onDismiss: onSubmit,
              children: [jsx(EGDSMenuTrigger, {
                children: jsx(EGDSTextInput, {
                  className: textInputClasses,
                  id: startProps.id,
                  name: startProps.name,
                  label: startLabel,
                  placeholder: startProps.placeholder,
                  value: value,
                  onChange: onChange,
                  "data-stid": "input-date",
                  icon: "today",
                  invalid: startProps.invalid,
                  children: isMounted && jsx(EGDSFauxInput, {
                    "aria-label": buttonLabel,
                    className: getClassNameList('uitk-form-field-trigger'),
                    domRef: startProps.domRef,
                    "data-name": startProps.name,
                    id: `${startProps.id}-btn`,
                    "data-stid": "open-date-picker",
                    type: "button",
                    onClick: setContext,
                    analytics: startProps.analytics,
                    children: formattedBtnText
                  })
                })
              }), showDatePicker && triggeredField === 'start' && jsx(EGDSMenuContainer, {
                position: PositionType.LEFT,
                className: containerClasses,
                autoPosition: true,
                children: jsx(EGDSDatePickerMenuView, {
                  ...enhancedDatePickerProps
                })
              })]
            })
          })
        })
      }), !singleMode && !useSingleTrigger && jsx(EGDSLayoutFlexItem, {
        className: fieldWrapperClasses,
        grow: 1,
        minWidth: "zero",
        maxWidth: stacked ? undefined : 'half_width',
        children: jsx("div", {
          children: jsx(MenuEndDateField, {
            ...props
          })
        })
      })]
    })
  });
};
MenuDateFields.displayName = 'MenuDateFields';
class DateField extends React.Component {
  static displayName = 'EGDSDateField';
  static defaultProps = {
    dateFormat: EGDSDatePickerDateFormat.YMD,
    space: 'three',
    triggeredField: 'start'
  };
  render() {
    const {
      useCustomTrigger,
      datePickerProps
    } = this.props;
    if (useCustomTrigger) {
      switch (datePickerProps.renderType) {
        case EGDSDatePickerRenderType.DIALOG:
          return jsx(CustomTriggerDialog, {
            ...this.props
          });
        case EGDSDatePickerRenderType.MENU:
          return jsx(CustomTriggerMenu, {
            ...this.props
          });
        default:
          return jsxs(Viewport, {
            children: [jsx(ViewSmall, {
              children: jsx(CustomTriggerDialog, {
                ...this.props
              })
            }), jsx(ViewLarge, {
              children: jsx(CustomTriggerMenu, {
                ...this.props
              })
            })]
          });
      }
    }
    switch (datePickerProps.renderType) {
      case EGDSDatePickerRenderType.DIALOG:
        return jsx(DialogDateFields, {
          ...this.props
        });
      case EGDSDatePickerRenderType.MENU:
        return jsx(MenuDateFields, {
          ...this.props
        });
      default:
        return jsxs(Viewport, {
          children: [jsx(ViewSmall, {
            children: jsx(DialogDateFields, {
              ...this.props
            })
          }), jsx(ViewLarge, {
            children: jsx(MenuDateFields, {
              ...this.props
            })
          })]
        });
    }
  }
}
const EGDSDateField = props => {
  const l10n = useLocalization();
  return jsx(DateField, {
    l10n: l10n,
    ...props
  });
};
EGDSDateField.displayName = 'EGDSDateField';
const EGDSNewDateField = EGDSDateField;
export { EGDSDateField, EGDSDatePickerDateFormat, EGDSNewDateField };